<template>
    <div>
        <div class="tab-item" >
            <div class="btn" >
            </div>
            <div class="red">
                <span v-if="themeDetail.needVerify == 1">需要场勘</span>
                <span v-else>不需要场勘</span>
                <span>/</span>
                <span v-if="themeDetail.needConstruct == 1">需要搭建</span>
                <span v-else>不需要搭建</span>
            </div>
            <div class="item">
                <div class="left">是否需要SPR</div>
                <div class="right">
                    <span v-if="themeDetail.needSpr == 1">是</span>
                    <span v-else> 否</span>
                </div>
            </div>
            <!-- <div class="item">
                <div class="left">是否需要督导打卡</div>
                <div class="right">
                    <span v-if="themeDetail.needSupervisor == 1">是</span>
                    <span v-else> 否</span>
                </div>
            </div> -->
            <div class="item">
                <div class="left">是否需要转场</div>
                <div class="right">
                    <span v-if="themeDetail.needTransitions == 1">是</span>
                    <span v-else> 否</span>
                </div>
            </div>
            <div class="item">
                <div class="left">装饰点位</div>
                <div class="right">
                    <span v-if="themeDetail.themeDecorates">
                        {{getDecorates(themeDetail.themeDecorates,'、')}}
                    </span>
                    <span v-else>暂无</span>
                </div>
            </div>
            <div class="item" v-if="themeDetail.needTransitions == 1">
                <div class="left">道具数量</div>
                <div class="right">
                    <span>{{ themeDetail.itemQuantity }}</span>
                </div>
            </div>
            <div class="item" v-else>
                <div class="left">
                    <span v-if="themeDetail.pocRelateType == '1'">每售点执行天数</span>
                    <span v-if ="themeDetail.pocRelateType == '2'">每街区执行天数</span>
                    <span v-if ="themeDetail.pocRelateType == '0'">每活动地点执行天数</span>
                </div>
                <div class="right">
                    <span>{{themeDetail.perExecDays}}</span>
                </div>
            </div>
            <div class="item">
                <div class="left">额度信息</div>
                <div class="right">
                    <span>{{themeDetail.totalCountQty}}{{ showText }}</span>
                    <span>（已通过：</span>
                    <span>{{themeDetail.passedCountQty}}{{ showText }}</span>
                    <span style="margin:0px 5px;">/</span>
                    <span>审核中：</span>
                    <span>{{themeDetail.approvalCountQty}}{{ showText }}</span>
                    <span style="margin:0px 5px;">/</span>
                    <span>未提报：</span>
                    <span>{{themeDetail.notReportCountQty}}{{ showText }}</span>
                    <span>）</span>
                </div>
            </div>
            <!-- v-if="themeDetail.passedCountQty > 0 || themeDetail.approvalCountQty > 0 " -->
            <div class="item-sale" >
                <div class="left">
                    <div class="left-left">售点信息</div>
                    <div class="left-right">
                        <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm" >
                            <el-form-item class="item" prop="buName">
                            <el-input v-model="searchForm.buName" placeholder="BU" size="small"></el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="regionName">
                            <el-input v-model="searchForm.regionName" placeholder="销售大区" size="small"></el-input>
                        </el-form-item>
                        <el-form-item class="item-btn">
                            <el-button type="danger" size="small" @click="submitForm()">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                        </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="right" v-loading="loading">
                    <el-table
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        border
                        show-header
                        :span-method="objectSpanMethod"
                        @selection-change="handleSelectionChange">
                        <!-- <el-table-column
                        type="selection"
                        align="center"
                        label='全选'
                        width="55">
                        </el-table-column> -->
                        <el-table-column
                        align="center"
                        label="BU"
                        width="70"
                        show-overflow-tooltip
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.buName">{{ scope.row.buName.split('|')[0] }}</span>
                            <span v-else></span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="销售大区"
                        width="100"
                        show-overflow-tooltip
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.regionName">{{ scope.row.regionName.split('|')[0] }}</span>
                            <span v-else></span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        prop="address"
                        label="城市"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ getName(scope.row.areaName)  }}</template>

                        </el-table-column>
                        <el-table-column
                        align="center"
                        prop="address"
                        :label="isEmptypoint? '活动地点':'街区名称'"
                        v-if="isManypoint || isEmptypoint"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.blockName }}</template>
                        </el-table-column>
                        <el-table-column
                        v-if="!isEmptypoint"
                        align="center"
                        label="售点名称"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="store-name" @click="clickStorename(scope.row)">{{ scope.row.pocName }}</div>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!isEmptypoint"
                        align="center"
                        label="售点地址"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.pocAddress }}</template>
                        </el-table-column>
                        <el-table-column
                        v-if="isEmptypoint"
                        align="center"
                        label="地址"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.blockAddress }}</template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="提报状态"
                        width="100"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.activityStatus == 0">待提交</span>
                                <span v-else-if="scope.row.activityStatus == 100">Region审批</span>
                                <span v-else-if="scope.row.activityStatus == 200">BU审批</span>
                                <span v-else-if="scope.row.activityStatus == 300">HQ审批</span>
                                <span v-else-if="scope.row.activityStatus == 350">待供应商确认</span>
                                <span v-else-if="scope.row.activityStatus == 400">执行中</span>
                                <span v-else-if="scope.row.activityStatus == 500">已完成</span>
                                <span v-else-if="scope.row.activityStatus == 900">关闭/取消</span>
                                <span v-else-if="scope.row.activityStatus == 1000">
                                    <span v-if="scope.row.rejectClientLevel == 'hq'">
                                        HQ退回
                                    </span>
                                    <span v-if="scope.row.rejectClientLevel == 'bu'">
                                        BU退回
                                    </span>
                                </span>
                                <span v-else>未知</span>

                            </div>
                        </template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="百威联系人"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.bwContactPerson }}</template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="活动时间"
                        >
                        <template slot-scope="scope">
                            <div  class="pickerOptionsNo"  style="display:flex;">
                                <div style="color:#409eff;margin:auto;" >
                                    {{ scope.row.timeList.length }}天
                                    <i class="el-icon-date" style="color:#409eff;cursor: pointer;" @click="clickDate(scope.row)"></i>
                                </div>
                                <el-date-picker
                                style="width:0px;overflow: hidden;"
                                :ref=" isEmptypoint ? 'changeFocus' + (scope.row.activityId) : 'changeFocus' + (scope.row.igniteId) "
                                popper-class="elDatePicker"
                                type="dates"
                                value-format="yyyy-MM-dd"
                                v-model="scope.row.timeListno"
                                :picker-options="pickerOptionsNo()"
                                placeholder="选择一个或多个日期"
                                size="small"
                                :clearable="false"
                                class="date-picker"
                                :default-value="defauleTime"
                                >
                                </el-date-picker>
                            </div>
                        </template>
                        </el-table-column>
                    </el-table>
                    <div class="dialog-bottom" v-if="tableData.length >0">
                        <el-pagination
                        background
                        :total="searchForm.total"
                        layout="total, prev, pager, next"
                        :current-page="searchForm.page"
                        :page-size="searchForm.pageSize"
                        @current-change="handleCurrentChange">
                        <span style="text-align: center">{{searchForm.page}}/{{Math.ceil(searchForm.total/searchForm.pageSize)}}</span>
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import gameplanApi  from '../../../api/gameplan'
    import DialogPop from './dialog-pop.vue'
    export default {
      name: 'submit-approval-pop-form',
      props: {
        popDataitem:{type:Object, default:()=>{}},
        queryCondition:{type:String}

      },
      components: {
        DialogPop
      },
      data () {
        return {
            tableData: [],
            themeDetail:{},
            multipleSelection: [],
            streetArr: [], // 街道数组
            streeIndex:0, // 下标
            isSon: false,
            searchForm: {
                prId: '', // PR编码
                prName: '', // PR名称
                activityName: '', // 活动名称
                selectBrand: '' , // 选择品牌
                selectChannel: '', // 选择渠道
                searchStatus: '',// 查询状态
                page: 1,
                pageSize: 5,
                total:0,
                buName:'',
                regionName:''
            },
            channelOptions: [], // 渠道下拉菜单
            brandOptions: [], // 品牌下拉菜单
            isSinglepoint: false,
            isManypoint: false,
            isEmptypoint: false,
            showText:'',
            defauleTime:'',
            pickerOptionsNo(row = {}) {
                return{
                    disabledDate (time) {
                        return true
                    },
                }
            },
            loading:false
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        if (this.popDataitem.themeLevelCode !== null) {
            this.popData = this.popDataitem
            this.themeDetail =  this.popDataitem.themeDetail
            this.pocCountMin =  this.popDataitem.themeDetail.pocCountMin
        } else {
            this.popData = this.popDataitem.data[0]
            this.themeDetail =  this.popDataitem.data[0].themeDetail
            this.pocCountMin =  this.popDataitem.data[0].themeDetail.pocCountMin
        }

        if (this.themeDetail.pocRelateType == '1') {
            this.isSinglepoint = true
            this.isManypoint = false
            this.isEmptypoint = false

        } else if (this.themeDetail.pocRelateType == '2') {
            this.isSinglepoint = false
            this.isManypoint = true
            this.isEmptypoint = false
        } else {
            this.isSinglepoint = false
            this.isManypoint = false
            this.isEmptypoint = true
        }
        this.init()
      },
      mounted () {},
      updated () {},
      methods: {
        init () {
            this.getActivitylist()
            this.getShowtext()
        },
        getName(str){
            if(str){
                return str.split('|')[0] || str
            }else return ''
        },
         // 点击图标显示日期组件
         clickDate (row) {
            // console.log(row,'clickDate');
            let min = Math.min(...row.timeList.map(item => new Date(item)));
            // console.log(min,'min-submit');
            this.defauleTime = new Date(min);
            this.defauleTime.setMonth(new Date(min).getMonth());
            if (this.isEmptypoint) {
                this.$nextTick(()=>{
                    this.$refs[`changeFocus${row.activityId}`].focus()
                })
            } else {
                this.$nextTick(()=>{
                    this.$refs[`changeFocus${row.igniteId}`].focus()
                })
            }
        },
        getShowtext () {
            let needTransitions = this.themeDetail.needTransitions
            let pocRelateType = this.themeDetail.pocRelateType
            if (needTransitions == 0) {
                if (pocRelateType == '0') {
                    this.showText = '地点'
                } else if (pocRelateType == '1') {
                    this.showText = '售点'                    
                } else if (pocRelateType == '2') {
                    this.showText = '街区'                    
                }

            } else if (needTransitions == 1) {
                this.showText = '场'
            } else {
                return
            }

        },
         //按buName regionName售点查询
        async getActivitylist () {
            let params = {
                'themeId':this.popData.themeDetail.themeId,
                'themeDetailId':this.popData.themeDetail.themeDetailId,
                'queryCondition':this.queryCondition,
                'page':this.searchForm.page,
                'pageSize':this.searchForm.pageSize,
                // 'queryCondition':'04',

                'buName':this.searchForm.buName,
                'regionName':this.searchForm.regionName,
            }
            this.loading = true
            let res =  await gameplanApi.getGamepalnActivitylist(params)
            if (res.data.resultCode == '0') {
                this.loading = false
                let tableList = res.data.resultData.activityList
                if (res.data.resultData.activityList !== null) {
                    this.searchForm.total = res.data.resultData.pageInfo.totalCounts
                    if (!this.isEmptypoint) {
                        let a = []
                        for (let index = 0; index < tableList.length; index++) {
                            let blockName = tableList[index].gpActivityInfoDTO.blockName
                            let buName = tableList[index].gpActivityInfoDTO.buName
                            let regionName = tableList[index].gpActivityInfoDTO.regionName
                            let activityStatus = tableList[index].gpActivityInfoDTO.activityStatus
                            let bwContactPerson = tableList[index].gpActivityInfoDTO.bwContactPerson
                            if (tableList[index].gpActivityTimeDTOList == null) {
                                tableList[index].gpActivityTimeDTOList = []
                            }
                            let timeList = tableList[index].gpActivityTimeDTOList.map(item =>{
                                return item.activityTime
                            })
                            if (tableList[index].gpActivityPocDTOList !== null) {
                                for (let item of  tableList[index].gpActivityPocDTOList) {
                                    item.blockName = blockName
                                    item.buName = buName
                                    item.regionName = regionName
                                    item.activityStatus = activityStatus
                                    item.bwContactPerson = bwContactPerson
                                    item.timeList = timeList
                                    item.timeListno = timeList
                                    a.push(item)
                                }                     
                            }
                        }
                        this.tableData = a
                        this.merge(this.tableData)
                    } else {
                        let a = []
                        for (let index = 0; index < tableList.length; index++) {
                            a.push(tableList[index].gpActivityInfoDTO)
                            if (tableList[index].gpActivityTimeDTOList == null) {
                                tableList[index].gpActivityTimeDTOList = []
                            }
                           let timeList = tableList[index].gpActivityTimeDTOList.map(item =>{
                                return item.activityTime
                            })
                            tableList[index].gpActivityInfoDTO.timeList = timeList
                            tableList[index].gpActivityInfoDTO.timeListno = timeList
                        }
                        this.tableData = a
                        this.merge(this.tableData)
                    }
                }
            } else {
                console.log('err');
                this.loading = false
            }
        },
        getTableData () {
            let tableList = this.popData.gpActivityInfoVOList || []
            let a = []

            for (let index = 0; index < tableList.length; index++) {
                let blockName = tableList[index].gpActivityInfoDTO.blockName
                let buName = tableList[index].gpActivityInfoDTO.buName
                let regionName = tableList[index].gpActivityInfoDTO.regionName
                let activityStatus = tableList[index].gpActivityInfoDTO.activityStatus
                let bwContactPerson = tableList[index].gpActivityInfoDTO.bwContactPerson
                // let rejectClientLevel = tableList[index].gpActivityInfoDTO.rejectClientLevel
                // let item of  tableList[index].gpActivityPocDTOList
                for (let item of  tableList[index].gpActivityPocDTOList) {
                    item.blockName = blockName
                    item.regionName = regionName
                    item.buName = buName
                    item.activityStatus = activityStatus
                    item.bwContactPerson = bwContactPerson
                    // item.rejectClientLevel = rejectClientLevel
                    a.push(item)
                }
            }
            this.tableData = a
            this.merge(this.tableData)
            // console.log(a,'tableData');
        },
        getDecorates(a,b){
            let arr = a.map((item) => {
                    return item.decorateName
                }).join(b)
            return arr
        },
        // 初始化合并行数组
        mergeInit() {
        this.streetArr = []; //合并街道
        this.streeIndex = 0; //合并街道索引
        },
        //  合并表格
        merge(data) {
            this.mergeInit();
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        //第一行必须存在，以第一行为基准
                        this.streetArr.push(1); //合并
                        this.streeIndex = 0;
                    } else {
                        // 判断当前元素与上一元素是否相同
                        // 合并街区列
                        if (data[i].activityId == data[i - 1].activityId) {
                        this.streetArr[this.streeIndex] += 1;
                        this.streetArr.push(0);
                        } else {
                        this.streetArr.push(1);
                        this.streeIndex = i;
                        }
                    }
                }
            }
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            const len = this.tableData.length;
            if (this.isManypoint) {
                // if ( columnIndex === 0 || columnIndex === 4) {
                // console.log('是组合多选');
                // const _row_2 = this.streetArr[rowIndex];
                // const _col_2 = _row_2 > 0 ? 1 : 0;
                // return {
                // rowspan: _row_2,
                // colspan: _col_2,
                // };
                if ( columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 7 || columnIndex === 8) {
                const _row_2 = this.streetArr[rowIndex];
                const _col_2 = _row_2 > 0 ? 1 : 0;
                return {
                rowspan: _row_2,
                colspan: _col_2,
                };
            }
            }
        },
        handleSelectionChange (val) {
            this.multipleSelection = val;
        },
        clickStorename (row) {
            this.$emit("clickStorename",row)
        },
        // 通过
        passThrough () {
            let item = this.multipleSelection
            this.$emit("passThrough",item)
        },
        // 退回
        sendBack () {
            let item = this.multipleSelection
            this.$emit("sendBack",item)
        },
         // 搜索
        submitForm (val) {
            this.$refs.searchForm.validate((valid) => {
            if (valid) {
                this.searchForm.page = 1
                this.getActivitylist()
            } else {
                return false;
            }
            });
        },
        handleCurrentChange (val) {
            this.searchForm.page = val
            this.getActivitylist()
        },
        // 重置
        resetForm () {
            this.$refs.searchForm.resetFields();
            this.getActivitylist()
        },
    }
}
</script>
<style lang="scss">
    .elDatePicker {
        .el-date-table td.selected span {
            background-color: rgb(222, 101, 45);
            color: #FFF;
            border-radius: 15px;
        }
        .el-picker-panel__footer {
            display: none;
        }
    }
</style>
<style lang="scss" scoped>
.tab-item {
    padding: 0px 10px 30px 30px;
    background-color: #FFFFFF;
    color: #101010;
    border-radius: 10px;
    font-family: SourceHanSansSC-bold;
    // height: 681px;
    font-size: 14px;
    text-align: left;
    // position: relative;
    ::v-deep.el-tabs__item.is-active {
        background-color: #FFFFFF;
        color: #409EFF;
    }

    .btn {
        display: flex;
        // width: 20%;
        justify-content: flex-end;
        margin-right: 17px;
        height: 30px;
        line-height: 30px;
    }
    .red {
        color: #CD1231;
        font-size: 16px;
        font-weight: bold;
        margin-top: -30px;
        height: 32px;
        line-height: 32px;
    }
    .item {
        // height: 32px;
        line-height: 32px;
        display: flex;
        .left {
            font-size: 16px;
            font-weight: bold;
            width: 20%;
        }
        .right {
            flex: 1;
        }
    }
    .item-sale {
        .left {
            font-size: 16px;
            font-weight: bold;
            height: 52px;
            line-height: 52px;
            display: flex;
            .left-left {
                width: 20%;
                // width: 47.5%;
                line-height: 42px;
            }
            .left-right {
                // width: 90%;
                .searchForm {
                    width: 100%;
                    display: flex;
                    .item {
                        width:160px;
                        ::v-deep .el-input__inner {
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }
                    .item-btn {
                        margin-left: 30px;
                    }
            }
            }
        }
        .right {
            width: 90%;
            margin-left: 5%;
            ::v-deep .el-table th.el-table__cell {
                color: #101010;
                background-color: rgba(232, 232, 232);
            }
            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: #FFFFFF !important;
            }
            .store-name {
                color: #409EFF;
                white-space: nowrap;/*设置不换行*/
                overflow: hidden; /*设置隐藏*/
                text-overflow: ellipsis; /*设置隐藏部分为省略号*/
                cursor: pointer;
            }
            .dialog-bottom {
                position: relative;
                top: 10px;
                text-align: right;
                // ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
                // background-color: #fff;
                // color: #409EFF;
                // border: 1px solid #409EFF
                // }
                // ::v-deep .el-pagination.is-background .el-pager li:hover {
                // color: #409EFF;
                // }
                ::v-deep .el-pagination.is-background .btn-next,
                ::v-deep .el-pagination.is-background .btn-prev{
                    background-color: #FFFFFF;
                    color: #000;
                    // width: 66px;
                    border: 1px solid #C0C4CC;
                    border-radius: 3px;
                }
                ::v-deep .el-pagination.is-background .btn-next:disabled,
                ::v-deep .el-pagination.is-background .btn-prev:disabled,
                ::v-deep .el-pagination.is-background .el-pager li.disabled {
                    color: #C0C4CC;
                }
            }
        }
    }
}
</style>
